export default "__VITE_ASSET__D5rk2K$y__"